import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-6919">
      <Navbar scrolled={scrolled} data-id="element-6920" />
      <main className="pt-24 pb-20" data-id="element-6921">
        <div className="container mx-auto px-4 md:px-6" data-id="element-6922">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-6923">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-6924">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-6925">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-6926" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6927">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-6928">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-6929">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-6930">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-6931">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6932">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-6933">
                <li className="flex items-start" data-id="element-6934">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6935">
                    •
                  </span>
                  <span data-id="element-6936">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-6937">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6938">
                    •
                  </span>
                  <span data-id="element-6939">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-6940">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6941">
                    •
                  </span>
                  <span data-id="element-6942">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-6943">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-6944">
                    •
                  </span>
                  <span data-id="element-6945">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-6946">
              <h2 className="text-xl font-semibold mb-2" data-id="element-6947">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-6948">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-6949">
                <div className="flex justify-between" data-id="element-6950">
                  <span data-id="element-6951">Monday - Friday:</span>
                  <span data-id="element-6952">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-6953">
                  <span data-id="element-6954">Saturday:</span>
                  <span data-id="element-6955">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-6956">
                  <span data-id="element-6957">Sunday:</span>
                  <span data-id="element-6958">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-6959" />
    </div>;
};